import React from 'react'
import { Flex, Text } from '@grammarly/design-system'

import { SignUpProductRecButton } from '@components/item/cta-button/signup-product-recommendation'
import { ButtonColor } from '@components/ui-lib/button'
import { useTool } from '../tool-context'

import styles from '../tool.module.scss'

export const ToolNextBestAction: React.FC = () => {
  const { isLoading, outputContent, nextBestActionCopy } = useTool()

  const isVisible = outputContent && !isLoading

  return (
    <Flex
      direction="row"
      align="center"
      justify="center"
      width="100%"
      padding={4}
      gap={6}
      className={styles.toolNextBestActionContainer}
      marginTop={4}
      style={{ opacity: isVisible ? 1 : 0 }}
      aria-hidden={!isVisible}
    >
      <Text variant="text-small" as="span" color="base-default" className={styles.toolNextBestActionCopy}>
        {nextBestActionCopy}
      </Text>

      <SignUpProductRecButton
        compact
        color={ButtonColor.WDK24SecondaryLightBg}
        text={
          <Text variant="text-medium" as="span" color="brand-default" className={styles.toolNextBestActionButton}>
            <b>Get Grammarly</b> It&apos;s Free
          </Text>
        }
        showArrow
        placement="Section"
        toQueryParam="editor"
      />
    </Flex>
  )
}
